import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import { Provider, connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga';
import { select, call, put, takeEvery, takeLatest, delay, all } from 'redux-saga/effects';

import reducer from './postcomponent/reducer';
import MySaga from './postcomponent/sagafunc';

import { changetitle } from './commonfunc/common';


interface BotState {
    baseJson: any; // 表示に使うページ
    CurrentPages: number; // 現在のページ
    PageMaxPost: number; // １ページあたりの表示数
    DateOrigin: any; // 日付
}

/**
 * 
 */
const fgetURL = () => {
    const url = document.getElementById("fetchUrl");
    //console.log("url is ",url.innerText);
    return url.innerText;
}
const fget_date_origin = () => {
    const dateorigin = document.getElementById("date_origin");
    //console.log("url is ",url.innerText);
    return dateorigin.innerText;
}
/**
 * 
 */
const fgetPages = () => {
    const pages = document.getElementById("pages");
    //console.log("url is ",url.innerText);
    return Number(pages.innerText);
}

/**
 * 
 */
class ListApp extends React.Component<any, BotState>{

    state: BotState = {
        baseJson: [],
        CurrentPages: fgetPages(),
        PageMaxPost: 100,
        DateOrigin: fget_date_origin(),
    }
    componentWillMount = () => {
    }
    componentWillUnmount = () => {
    }
    componentDidMount() {
        // initialize saga
        this.props.dispatch({ type: "Ajax_Get_Post", url: fgetURL() })
    }
    componentWillReceiveProps() {
    }

    public headercontents:any = "";


    /**
     * 
     * 
     * render
     * 
     * 
     */
    public render() {
        //console.log("baseJson is ", this.props.baseJson);
        if (this.props.baseJson.count != 0) {

            // botu
            //const start = this.state.CurrentPages * this.state.PageMaxPost;
            //const goal = (this.state.CurrentPages + 1) * this.state.PageMaxPost;
            //const baseJson = this.props.baseJson.data.slice(start, goal);
            const baseJson = this.props.baseJson.data;
            console.log("baseJson is ", baseJson);


            /** page list */
            //const PagingAll = Math.ceil(this.props.baseJson.count / this.state.PageMaxPost);


            //const ItemList = this.props.baseJson.data.map((v: any, i: any) => {
            const ItemList = baseJson.map((v: any, i: any) => {

                const urls = "/list/detail.php?date=" + this.state.DateOrigin + "&pages=" + (this.state.CurrentPages + 1) + "&ids=" + v.id;
                console.log("action live check");

                let first = "";
                if(i==0){
                    this.headercontents = `
                            注目の１位は 「　${v.categories}　」カテゴリーにおいて、
                            「　${v.price}　円　」で落札された　「　${changetitle(v.title)} 」　でした。
                            <br><br>`;
                    
                }
                if(i==1){
                    const linkurl = "/list/index.php?date=" + this.state.DateOrigin + "&pages=1";

                    this.headercontents += `
                            <br>２位は　「 ${v.categories}　」カテゴリーにおいて、
                            「　${v.price}円　」　で落札された　「　${changetitle(v.title)} 」でした。<br><br><br>
                            トップ２０以外のリストに関しては
                            <a className="linkintitle" href=${linkurl} >▶コチラ</a>を参照してください。
                            <span classz="clear"></span>`;
                }



                if ( i < 3 ) {
                    return (

                        <li className="img-auc-item" key={i}>
                            <a href={urls}>
                            <span className="juni">第{i+1}位 {v.price}円</span>
                            {changetitle(v.title)}
                            <img src={v.main_image} alt={v.title} />
                            </a>
                        </li>
                    );
                } else if ( ( i > 2 ) && ( i < 11 ) ) {
                    return (
                        <li className="img-auc-item-m" key={i}>
                            <a href={urls}>
                            <span className="juni3to10">第{i+1}位 {v.price}円</span>
                            {changetitle(v.title)}
                            <img src={v.main_image} alt={v.title} />
                            </a>
                        </li>
                    );
                } else {
                    return (
                        <li className="auc-item" key={i}>
                            <a href={urls}>
                            <span className="juni10to20">第{i+1}位 {v.price}円</span>                            
                            {changetitle(v.title)}
                            {/* <img src={v.main_image} alt={v.title} /> */}
                            </a>
                        </li>
                    );
                }

            });

            return (
                <div>
                    <div dangerouslySetInnerHTML={{__html : this.headercontents}} ></div>
                    <hr />

                    <ul id="auclists">
                        {ItemList}
                    </ul>
                    <hr />
                    <span className="clear"></span>
                    <br /><br />
                    トイズキング・オークションでは毎日１円スタートで様々なコレクターズ商品を販売しております。
                    <br />新旧商品のコンプリートやレア物をお探しの方は是非「トイズキング・オークション」をご利用ください！！
                </div>
            );
        } else {
            return (
                <p>
                    now loading
                </p>
            );

        }
    }

}







/**
 * 1-3 set App
 */
const App: any = (() => {
    const mapStatetoProps = (state: any) => {
        return { ...state };
    }
    return connect(mapStatetoProps)(ListApp);
})();

/**
 * 3-4 sagaMiddleware
 */
const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(MySaga);




ReactDOM.render(
    <div>
        <Provider store={store} >
            <App />
        </Provider>
    </div>
    ,
    document.getElementById("app")
);
